/**
 * Customer Logo Filter
 * Vanilla JS implementation for filtering customer logos without mixitup library
 * Fade animations handled via CSS transitions
 */
(function() {
    const FADE_DURATION = 600; // milliseconds
    const FADE_CLASS = 'is-filtered-out';

    function initCustomerFilter() {
        const containerElement = document.querySelector('.customer-logo-list');
        if (!containerElement) return;

        const filterButtons = document.querySelectorAll('.customer-filter-button');
        const items = containerElement.querySelectorAll('li');

        // Add data attribute to track original display state
        items.forEach(item => {
            item.dataset.hasClasses = item.className;
        });

        filterButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                const filterValue = this.getAttribute('data-filter');
                
                // Update active button styling
                filterButtons.forEach(btn => {
                    btn.classList.remove('mixitup-control-active');
                });
                this.classList.add('mixitup-control-active');

                // Filter items
                filterItems(items, filterValue);
            });
        });

        // Set initial active state on "All" button
        const allButton = document.querySelector('[data-filter="all"]');
        if (allButton) {
            allButton.classList.add('mixitup-control-active');
        }
    }

    function filterItems(items, filterValue) {
        items.forEach(item => {
            const shouldShow = filterValue === 'all' || item.classList.contains(filterValue.substring(1));
            
            if (shouldShow) {
                // Show item - restore display, remove filtered class to trigger scale + fade in
                item.style.display = '';
                // Use requestAnimationFrame to ensure display takes effect before animation
                requestAnimationFrame(() => {
                    item.classList.remove(FADE_CLASS);
                });
            } else {
                // Hide item - fade out and scale down, then hide after animation
                item.classList.add(FADE_CLASS);
                setTimeout(() => {
                    if (item.classList.contains(FADE_CLASS)) {
                        item.style.display = 'none';
                    }
                }, 400); // Match the opacity transition duration (400ms)
            }
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCustomerFilter);
    } else {
        initCustomerFilter();
    }
})();
